import * as React from 'react';

import DittoMascot from '@imgs/dittoiconsmall.png';
import { Box, Flex, Stack, Text } from '@ui';

interface DittoAdviceProps {
  advice: string;
}

const DittoAdvice: React.FC<DittoAdviceProps> = React.memo(({ advice }) => {
  return (
    <Box py={12} px={16} bg="#F7FAF5" mb="sm" mt="sm">
      <Flex direction="row" w="100%">
        <img
          src={DittoMascot}
          style={{ width: 40, height: 40, marginRight: '8px' }}
          alt="ditto-logo-small"
        />
        <Stack gap={4}>
          <Text fw="bold" c="primary">
            Ditto advice
          </Text>
          <Text size="sm" c="#525454">
            {advice}
          </Text>
        </Stack>
      </Flex>
    </Box>
  );
});

export { DittoAdvice };
